import axios from 'axios'
import {
	Notification
} from 'element-ui';
let md5 = require('md5');
// 接口域名
const pcHost = 'https://new.suhuishou.com/api'
const h5Host = '/api/v2'
const _83k8xd = '1046'
const _djkadkj = '4QrcOUm6Wau+VuBX8g+IPg=='


// axios 配置
axios.defaults.timeout = 10000;
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
// withCredentials: true;
//POST传参序列化
axios.interceptors.request.use(async (config) => {
	let _data = config.params
	
	if (config.method === 'post') {
		// config.data = qs.stringify(config.data);
		_data = config.data
	}
	config.headers.partnerId = _83k8xd
	
	config.headers["shs-sign"] = signs(_data)
	return config;
},
	(error) => {
		alert('错误的传参');
		return Promise.reject(error);
	});

//返回状态判断
axios.interceptors.response.use(async (response) => {
	if (response.status != 200) {
		return Promise.reject(response);
	} else {
		return response;
	}
}, function (err) {
	if (err && err.response) {
		switch (err.response.status) {
			case 400:
				err.message = '请求错误(400)';
				break;
			case 401:
				err.message = '未授权，请重新登录(401)';
				break;
			case 403:
				err.message = '拒绝访问(403)';
				break;
			case 404:
				err.message = '请求出错(404)';
				break;
			case 408:
				err.message = '请求超时(408)';
				break;
			case 500:
				err.message = '服务器错误(500)';
				break;
			case 501:
				err.message = '服务未实现(501)';
				break;
			case 502:
				err.message = '网络错误(502)';
				break;
			case 503:
				err.message = '服务不可用(503)';
				break;
			case 504:
				err.message = '网络超时(504)';
				break;
			case 505:
				err.message = 'HTTP版本不受支持(505)';
				break;
			default:
				err.message = `连接出错(${err.response.status})!`;
		}
	} else {
		err.message = '连接服务器失败!'
	}
	Notification.error({
		title: '错误',
		message: err.message
	});
	return Promise.reject(err);
});

export function signs(params) {
	let keys = [];
	let sortParams = {};
	let key = 0;
	const timestamp = Date.parse(new Date())
	params.partnerId = _83k8xd
	params.platform = "sftc"

	params.timestamp = timestamp.toString();
	for (key in params) {
		keys.push(key);
	}
	keys.sort();
	for (key in keys) {
		sortParams[keys[key]] = params[keys[key]].toString()
	}
	const str = _djkadkj+JSON.stringify(sortParams)+_djkadkj
	// console.log(str)
	return md5(str);
}

export function fetch(url, params) {
	if (params === undefined) {
		params = {};
	}
	params['timestamp'] = Date.parse(new Date()) / 1000;
	return new Promise((resolve, reject) => {
		
		axios.get(url, params).then(response => {
			resolve(response.data);
		},
			err => {
				reject(err);
			}).catch((error) => {
				reject(error)
			})
	})
}

export function get(url, params) {
	return new Promise((resolve, reject) => {
		axios.get(url, {params:params}).then(response => {
			resolve(response.data);
		},
			err => {
				reject(err);
			}).catch((error) => {
				reject(error)
			})
	})
}

export function postFetch(url, params) {
	params['timestamp'] = Date.parse(new Date()) / 1000;
	let param = signs(params);
	return new Promise((resolve, reject) => {
		axios.post(url, param)
			.then(response => {
				resolve(response.data);
			}, err => {
				reject(err);
			})
			.catch((error) => {
				reject(error)
			})
	})
}

export function post(url, data) {
	return new Promise((resolve, reject) => {
		axios.post(url, data, { headers: {'content-type': 'application/json'} })
			.then(response => {
				resolve(response.data);
			}, err => {
				reject(err);
			})
			.catch((error) => {
				reject(error)
			})
	})
}

export default {
	Goods(params) {
		return fetch(`${pcHost}/goods`, params)
	},
	Product(id) {
		return get(`${h5Host}/product/detail`, { id, type: 1 })
	},
	Assess(params) {
		return post(`${h5Host}/evaluate`, params)
	},
	Brands(params) {
		return fetch(`${pcHost}/cat/brands`, params)
	},
	Stats(params) {
		return postFetch(`${pcHost}/index/stats`, params)
	},
	Zhima(params) {
		return fetch(`${pcHost}/zmop`, params)
	},
	isCity(params) {
		return fetch(`${pcHost}/index/iscity`, params)
	},
	Region(params) {
		return fetch(`${pcHost}/index/region`, params)
	},
	User(params) {
		return postFetch(`${pcHost}/zmop/user`, params)
	},
	Checkout(params) {
		return post(`${h5Host}/order/create/v2`, params)
	},
	Articles(params) {
		return fetch(`${pcHost}/article`, params)
	},
	Orders(params) {
		return fetch(`${pcHost}/user/order`, params)
	},
	Order(params) {
		return fetch(`${pcHost}/user/order/${params.id}`, params)
	},
	Cancel(params) {
		return postFetch(`${pcHost}/order/cancel`, params)
	},
	Express(params) {
		return postFetch(`${pcHost}/order/express`, params)
	},
	Test(params) {
		return fetch(`${pcHost}/first/t`, params)
	},
	Comment(params) {
		return fetch(`${pcHost}/comment`, params)
	},
	Status(id) {
		return fetch(`${pcHost}/order/status/${id}`)
	},
	Article(id) {
		return fetch(`${pcHost}/article/${id}`)
	},
	hotWord() {
		return fetch(`${pcHost}/first/hotword`)
	},
	Recent(params) {
		return fetch(`${pcHost}/order/recent`, params)
	},
	Cart(params) {
		return fetch(`${pcHost}/cart/goods`, params)
	},
	Maps(params) {
		return fetch(`${pcHost}/map`, params)
	},
	Login(params) {
		return post(`${h5Host}/centre/user/login`, params)
	},
	Bonus(params) {
		return fetch(`${pcHost}/bonus/list`, params)
	},
	bonusList(params) {
		return fetch(`${pcHost}/bonus/list`, params)
	},
	Token(params) {
		return postFetch(`${pcHost}/token`, params)
	},
	AtBonus(params) {
		// return 1234;
	},
	Wallet(params) {
		return postFetch(`${pcHost}/wallet/add`, params)
	},
	Wallets(params) {
		return fetch(`${pcHost}/wallet`, params)
	},
	reWallet(params) {
		return postFetch(`${pcHost}/wallet/release`, params)
	},
	Account(params) {
		return fetch(`${pcHost}/account`, params)
	},
	Sms(params) {
		return post(`${h5Host}/centre/user/send`, params)
	},
	Invite(params) {
		return fetch(`${pcHost}/order/invite`, params)
	},
	Oldnews(params) {
		return fetch(`${pcHost}/oldnew/order/list`, params)
	},
	Oldnew(params) {
		return fetch(`${pcHost}/oldnew/order/${params.id}`, params)
	},
	Test(params) {
		return post(`/api/v3/activity/quanminkangyi`, params)
	},
}


// WEBPACK FOOTER //
// ./src/store/fetch.js